import { useParams } from "react-router-dom"
import Loading from "components/loading"
import { useAccountAlias } from "resources/account"
import { useFetchEmbedUrl } from "./hooks/use-fetch-embed-url"
import useValidateUserAccess from "./hooks/use-validate-user-access"
import ErrorState from "./components/error-state"
import "./style.scss"

export default function SigmaEmbed() {
  const { sigmaResourceId = "" } = useParams<{ sigmaResourceId: string }>()
  const accountAlias = useAccountAlias()

  const { embedUrl, isPending, isError, error } = useFetchEmbedUrl(accountAlias, sigmaResourceId)
  const hasAccess = useValidateUserAccess(accountAlias, sigmaResourceId)

  if (isPending) {
    return <Loading />
  }

  if (isError || !embedUrl || !hasAccess) {
    const status = !hasAccess ? 403 : (error as { code?: number })?.code
    return <ErrorState status={status} />
  }

  return (
    <iframe
      src={embedUrl}
      className="sigma-embed-iframe"
      title="Solution"
      allowFullScreen
    />
  )
}
